<template>
  <div class="input_box" v-bind:class="{hasError : errorStatus}">

    <label class="left">{{item.label}}</label>

    <p v-show="showErrorMessage" class="errorMsg">{{errorMsg}}</p>
    <div class="inlineBoxInput">
      <input
        v-bind="$attrs"
        v-model.trim="value"
        v-on:blur="eventBlur"
        v-on:focus="eventFocus"
        v-mask="item.mask"
        :name="refs"
        :type="item.type"
        v-bind:style="colorBorder"
      />
    </div>

    <i v-if="item.info.length > 0">{{item.info}}</i>
  </div>

</template>

<script>
  import DataForInput from '@/gavnoCode/longFormOptions';
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "formInput",
    data: function () {
      return {
        item: DataForInput[this.refs],
        isTimeToShowError:false
      }
    },
    props: {
      refs: {
        type: String,
        default: 'null'
      },
      form:{
        type: String,
        default: 'null'
      }
    },
    methods: {
      eventBlur: function () {
        this.isTimeToShowError = true;
      },
      eventFocus: function(){
        this.isTimeToShowError = false;
      }
    },
    watch: {

    },
    mounted() {

    },
    computed: {
      status :function(){
        return this.statusVuex[this.form][this.refs].code;
      },
      errorMsg :function(){
        return this.statusVuex[this.form][this.refs].msg;
      },
      showErrorMessage:function(){
        return this.status != 0 && this.isTimeToShowError;
      },
      colorBorder: function () {
        switch (this.status) {
          case 1:
            return 'border-color:#b7b7b7;';
          case 0:
            return 'border-color:green;';
          default:
            return 'border-color:red;';
        }
      },
      value:{
        get(){
          return this.valueVuex[this.form][this.refs]
        },
        set(value){
          let utiputi = {
            target:this.refs,
            form:this.form,
            value: value
          };
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      errorStatus:function () {
        return false
      },
      ...mapGetters(['getTargetFieldValue']),
      ...mapState({
        valueVuex: state => state.requestField.sendData,
        statusVuex: state => state.requestField.workData
      })
    }

  }
</script>

<style scoped>
  .input_box {
    /*padding: 10px 0;*/
  }

  .input_box label {
    text-align: left;
    display: block
  }

  .inlineBoxInput {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .inputBoxStatus {
    width: 40px;
  }
  i{font-size: 13px;color:rgb(15, 87, 64)}
  .errorMsg{color:red}

</style>
